import {
    Component,
    Input,
    Output,
    ContentChildren,
    forwardRef,
    ViewEncapsulation,
    Injectable,
    EventEmitter
} from '@angular/core';
import {
    Validator,
    AbstractControl,
    ControlValueAccessor,
    NG_VALUE_ACCESSOR,
    NG_VALIDATORS
} from '@angular/forms';
import { SmRadioItemComponent } from './sm-radio-item.component';

import { SelectValidator, SelectValueAccessor } from '../forms';

@Component({
    selector: 'sm-radio-group',
    template: `<div class="radio-group"><ng-content></ng-content></div>`,
    providers: [
        SelectValueAccessor,
        SelectValidator,
        { provide: NG_VALUE_ACCESSOR, useExisting: SelectValueAccessor, multi: true },
        { provide: NG_VALIDATORS, useExisting: SelectValidator, multi: true }
    ]
})
export class SmRadioGroupComponent {
    @Input() disabled: boolean = false;
    @Input() readonly: boolean = false;
    @Input() customToggleLogic: (options: { event: MouseEvent, valueAccessor: SelectValueAccessor, value: any }) => void;
    @Input() customIsSelectedLogic: (options: { valueAccessor: SelectValueAccessor, value: any }) => void;

    @Input()
    set trackBy(trackBy: string | ((item: any) => string)) {
        this.valueAccessor.trackBy = trackBy;
    }
    get trackBy() {
        return this.valueAccessor.trackBy;
    }

    @Input()
    set required(required: boolean) {
        this.validator.options.required = required;
    }
    get required() {
        return this.validator.options.required;
    }

    @ContentChildren(forwardRef(() => SmRadioItemComponent))
    radioItems: SmRadioItemComponent[];

    constructor(public valueAccessor: SelectValueAccessor,
        private validator: SelectValidator) {
    }

    get values() {
        if (!this.radioItems) { return []; }
        return this.radioItems.map(radioItem => radioItem.value);
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./app/core/components/sm-radio-group.component.ts